import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  constructor() { }

  hideSpinner() {
    // Setting display of spinner
    // element to none
    document.getElementById('loading')
      .style.display = 'none';
    document.getElementById('col-sm-10')
      .style.backgroundColor = 'white';
    document.getElementById('cy')
      .style.zIndex = '1';
  }

  showSpinner() {
    document.getElementById('loading')
      .style.display = 'block';
    document.getElementById('col-sm-10')
      .style.backgroundColor = 'rgb(169 167 167 / 71%)';
    document.getElementById('cy')
      .style.zIndex = '-1';
    // nascondo panel
    const panel = document.getElementById('panel');
    panel.style.display = 'none';
  }
}
